export class NumberFunctionsGlobals {
    constructor() {
        this.blockLetters = (key) => {
            const char = key.keyCode;
            if (!((char > 47 && char < 58) ||
                (char > 94 && char < 106) ||
                char === 39 ||
                char === 37 ||
                char === 8 ||
                char === 9 ||
                char === 46)) {
                key.preventDefault();
            }
        };
        this.blockNumbers = (key) => {
            const char = key.keyCode;
            if ((char > 47 && char < 58) ||
                (char > 94 && char < 106) ||
                char === 39 ||
                char === 37 ||
                char === 46) {
                key.preventDefault();
            }
        };
        this.extractRawValue = (input) => {
            if (typeof input === "string") {
                return [input];
            }
            if (input instanceof Event && input.target instanceof HTMLInputElement) {
                return [input.target.value, input.target];
            }
            return [""];
        };
        this.addThousandsSeparator = (input) => {
            const [rawValue, element] = this.extractRawValue(input);
            const cleaned = rawValue.replace(/[^\d]/g, '');
            if (!cleaned)
                return "";
            const formatted = new Intl.NumberFormat('es-CO').format(Number(cleaned));
            if (element)
                element.value = formatted;
            return formatted;
        };
        this.formatInputCurrency = (input, symbol = true) => {
            const number = this.addThousandsSeparator(input);
            const result = number
                ? `${symbol ? "$ " : ""}${number}`
                : "";
            const [, element] = this.extractRawValue(input);
            if (element)
                element.value = result;
            return result;
        };
    }
}
export const numberFunctions = new NumberFunctionsGlobals();
